/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SlaOsListAliases {
  AUTOCOMPLETE_TYPE = 'autocomplete-type',
  CONTEXTUAL_BAR_SLA_OS_LIST = 'contextual-bar-sla-os-list',
  FETCH_SLA_OS_LIST = 'fetch-sla-os-list',
  FIELD_TYPE = 'field-type',
  LAYOUT_SLA_OS_LIST = 'layout-sla-os-list',
  MAPPER_TYPE = 'mapper-type',
  PAGINATOR_SLA_OS_LIST = 'paginator-sla-os-list',
  PANEL_FILTER = 'panel-filter',
  PANEL_SLA_OS_LIST = 'panel-sla-os-list',
  TABLE_COLUMN_BEGIN = 'table-column-begin',
  TABLE_COLUMN_END = 'table-column-end',
  TABLE_COLUMN_OS = 'table-column-os',
  TABLE_COLUMN_RESPONSE_TIME = 'table-column-response-time',
  TABLE_COLUMN_RULE = 'table-column-rule',
  TABLE_COLUMN_SOLUTION_TIME = 'table-column-solution-time',
  TABLE_COLUMN_STATUS = 'table-column-status',
  TABLE_COLUMN_TYPE = 'table-column-type',
  TABLE_SLA_OS_LIST = 'table-sla-os-list',
  TEXT_TYPE = 'text-type',
}
export { SlaOsListAliases };
